import { Card, Collapse, Grid, Title } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import React from 'react'

import { Basic } from './Basic'
import { Controlled } from './Controlled'
import { Disabled } from './Disabled'
import { FullWidth } from './FullWidth'
import { Icon } from './Icon'
import { Size } from './Size'

export const SegmentedControlComponentsDemo: React.FC = () => {
    const [opened, { toggle }] = useDisclosure(true)
    return (
        <Card withBorder>
            <Title order={2} onClick={toggle}>
                SegmentedControl
            </Title>
            <Collapse in={opened}>
                <Grid gutter={20}>
                    <Grid.Col span={6}>
                        <Basic />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Controlled />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <FullWidth />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Size />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Disabled />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Icon />
                    </Grid.Col>
                </Grid>
            </Collapse>
        </Card>
    )
}
